/* eslint-disable react/no-unstable-nested-components */
import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { AppContainer } from 'client/components/app/app.container';
import { Error } from 'client/components/error/error';
import urls from 'utils/urls';

const ErrorsApp = (props) => (
    <AppContainer {...props}>
        <Switch>
            <Route component={() => <Error code={403} />} path={urls.forbidden} exact />
            <Route component={() => <Error code={404} />} path={urls.all} />
        </Switch>
    </AppContainer>
);

export default ErrorsApp;
